import { Type } from '@scalar/typebox';
import { getBooleanSchema } from './helpers/get-boolean-schema.js';
import { getResolvedRef, mergeSiblingReferences } from './helpers/get-resolved-ref.js';
import { compose } from './schemas/compose.js';
import { coerceValue } from './schemas/typebox-coerce.js';
import { SchemaObjectSchema } from './schemas/v3.2/strict/openapi-document.js';
/**
 * The coercion target: a schema object that may still carry the `$ref` it was resolved from.
 *
 * `Type.Composite` merges every property of `SchemaObjectSchema` to build this, so it belongs at module
 * scope. `resolve.schema` runs once per property of every schema a render walks, and rebuilding the
 * composite per call dominated that walk.
 */
// Rendering also consumes AsyncAPI schemas. Keep boolean children intact until their own rows
// resolve them, without widening the object-based OpenAPI document validation types.
const displaySchemaObject = {
    ...SchemaObjectSchema,
    $defs: {
        ...SchemaObjectSchema.$defs,
        SchemaObject: Type.Union([SchemaObjectSchema.$defs.SchemaObject, Type.Boolean()]),
    },
};
const resolvedSchemaSchema = compose(displaySchemaObject, Type.Object({ $ref: Type.Optional(Type.String()) }));
export const resolve = {
    schema: (schema) => {
        if (schema === undefined) {
            return undefined;
        }
        // Resolve boolean targets before merging siblings, which assumes an object target.
        const target = getResolvedRef(schema);
        if (typeof target === 'boolean') {
            return getBooleanSchema(target);
        }
        const resoled = getResolvedRef(schema, mergeSiblingReferences);
        return coerceValue(resolvedSchemaSchema, resoled);
    },
};
